const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory } = require('react-router-dom')
const { Row, Col, UncontrolledTooltip } = require('reactstrap')
const { useHexToString, useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')

require('@styles/pages/block/consensus.block.css')

const BlockConsensus = props => {
    const { loading, data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatHexToString = useHexToString()
    const isMobile = useResponsive(BREAKPOINTS.small)

    const [consensusDetails, setConsensusDetails] = useState([])

    useEffect(() => {
        if (!data) return

        const fields = {
            divider: {
                id: 'divider'
            },
            slot: {
                id: 'block-slot',
                label: 'Slot',
                value: (
                    <span
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={() => {
                            history.push(`/${network.name}/slot/${data.beacon.slot}`)
                        }}
                    >
                        {data.beacon.slot}
                    </span>
                ),
                tooltip: 'The slot for which this block is created.'
            },
            epoch: {
                id: 'block-epoch',
                label: 'Epoch',
                value: (
                    <span
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={() => {
                            history.push(`/${network.name}/epoch/${data.beacon.epoch}`)
                        }}
                    >
                        {data.beacon.epoch}
                    </span>
                ),
                tooltip: 'The epoch of the current slot.'
            },
            proposerIndex: {
                id: 'block-proposer-index',
                label: 'Proposer Index',
                value: (
                    <span
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={() => {
                            history.push(`/${network.name}/validator/${data.beacon.proposerIndex}`)
                        }}
                    >
                        {data.beacon.proposerIndex}
                    </span>
                ),
                tooltip: 'The Proposer of the current block.'
            },
            rootHash: {
                id: 'block-slot-root-hash',
                label: 'Slot Root Hash',
                value: data.beacon.blockRoot,
                tooltip: '32 byte root hash of the current slot.'
            },
            parentRootHash: {
                id: 'block-parent-root-hash',
                label: 'Parent Root Hash',
                value: data.parentBeaconBlockRoot,
                tooltip: 'Root hash of the parent slot.'
            },
            depositCount: {
                id: 'block-beacon-chain-deposit-count',
                label: 'Beacon Chain Deposit Count',
                value: data.beacon.depositCount,
                tooltip: 'Number of successful deposits on the deposit contract so far.'
            },
            graffiti: {
                id: 'block-slot-graffiti',
                label: 'Slot Graffiti',
                value: (
                    <span>
                        {data.beacon.graffiti ? formatHexToString(data.beacon.graffiti) : '0x'} (Hex:{' '}
                        {data.beacon.graffiti ? data.beacon.graffiti : 'Null'})
                    </span>
                ),
                tooltip: '32 bytes for validator to decorate as they choose with no defined in-protocol use.'
            },
            blockRandomness: {
                id: 'block-randomness',
                label: 'Block Randomness',
                value: data.beacon.blockRandomness,
                tooltip: 'Source of randomness from the beacon chain RANDAO implementation.'
            },
            randaoReveal: {
                id: 'block-randao-reveal',
                label: 'Randao Reveal',
                value: data.beacon.randaoReveal,
                tooltip:
                    "The signature of the current epoch by the block proposer. Constitutes the seed for randomness when mixed in with the other proposer's reveals."
            }
        }

        const consensusOrder = [
            'slot',
            'epoch',
            'proposerIndex',
            'divider',
            'rootHash',
            'parentRootHash',
            'depositCount',
            'graffiti',
            'blockRandomness',
            'randaoReveal'
        ]

        setConsensusDetails(consensusOrder.map(key => fields[key]))
    }, [data])

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {consensusDetails.map(item => (
                        <Row className='table-info-row' noGutters>
                            {item.id === 'divider' ? (
                                <div className='table-divider' />
                            ) : (
                                <>
                                    <Col xs={12} sm={4} className='d-flex align-items-start'>
                                        <span className='info-icon-wrapper' id={item.id}>
                                            <i className='fas fa-question-circle info-icon' />
                                        </span>
                                        <span className='info-label'>{item.label}:</span>
                                    </Col>
                                    <UncontrolledTooltip placement='top' target={item.id}>
                                        {item.tooltip}
                                    </UncontrolledTooltip>
                                    <Col
                                        xs={12}
                                        sm={8}
                                        className={`d-flex align-items-center ${isMobile && 'mt-2'}`}
                                        style={{ flexWrap: 'wrap', wordBreak: 'break-all' }}
                                    >
                                        <span className='info-value' style={{ width: '100%' }}>
                                            {item.value}
                                        </span>
                                    </Col>
                                </>
                            )}
                        </Row>
                    ))}
                </>
            )}
        </div>
    )
}

module.exports = { BlockConsensus }
